import * as React from 'react';
import { PortableText } from '@portabletext/react';

interface HeaderDescriptionProps {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	description?: any;
	subtitle?: string;
}

export const HeaderDescription: React.FC<HeaderDescriptionProps> = ({
	description,
	subtitle,
}) => {
	// If we have rich text content from Sanity
	if (description) {
		return (
			<div className='mt-6 text-2xl md:leading-10 md:max-w-2/3 font-normal'>
				<PortableText
					value={description}
					components={{
						block: {
							normal: ({ children }) => (
								<p className='font-normal'>{children}</p>
							),
						},
						marks: {
							strong: ({ children }) => (
								<span className='font-semibold'>{children}</span>
							),
						},
					}}
				/>
			</div>
		);
	}

	// Otherwise use subtitle or fallback to hardcoded text
	return (
		<p className='mt-6 text-2xl md:leading-10 md:max-w-2/3'>
			{subtitle || (
				<>
					<span className='font-normal'>
						These services are guaranteed to{' '}
						<span className='font-normal'>uncover your</span>
					</span>{' '}
					authentic voice,{' '}
					<span className='font-normal'>and give you confidence.</span>
				</>
			)}
		</p>
	);
};
